import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=4ab055a0&scoped=true"
import script from "./SidebarItem.ts?vue&type=script&lang=ts&external"
export * from "./SidebarItem.ts?vue&type=script&lang=ts&external"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=4ab055a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab055a0",
  null
  
)

export default component.exports